import { render } from "./App.vue?vue&type=template&id=c32d3a2c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=c32d3a2c&lang=css"

import exportComponent from "C:\\Users\\krili\\Projects\\krilin_website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__